import { useState, useEffect, useCallback } from 'react';
import { getYearAgreement36Data, getYearInfoAgreement36Data, getDetailStaffAgreement36 } from 'api/agreement36';
import useToastNotification from 'hooks/useToastNotification';
import moment from 'moment';
import { useOrgTreesByYear } from 'hooks/useOrgTreesOptions';
import { Attend36AgreementsAlertData } from './../type';

const { errorNotification, successNotification } = useToastNotification();

export type YearlyAgreement36Data = {
  agreementsId: string;
  targetYear: number;
  applyStartMonth: Date;
  yearOvertimeList: Array<number>|null;
  yearOvertimeHourList: Array<number>|null;
  monthlyOverConditionsCountList: Array<number>|null;
  monthOverConditionsHour: number;
  monthlyOverAndHolidayTimeHour: number;
}
export type YearlyInfoAgreement36Data = {
  staffCode: string;
  staffName: string;
  orgCode: string;
  orgName: string;
  overTimeYear: number;
  overTimeYearHour: number;
  aveOverAlertCnt: number;
  overTimeAlertCnt: number;
  overHolidayTimeAlertCnt: number;
  overTimeYearFlag: number;
  aveOverFlag: number;
  overTimeFlag: number;
  overHolidayTimeFlag: number;
}
const initYearlyAgreement36Data: YearlyAgreement36Data = {
  agreementsId: '',
  targetYear: 0,
  applyStartMonth: new Date(),
  yearOvertimeList: null,
  yearOvertimeHourList: null,
  monthlyOverConditionsCountList: null,
  monthOverConditionsHour: 0,
  monthlyOverAndHolidayTimeHour: 0,
}

const testYearlyAgreement36Data: YearlyAgreement36Data = {
  agreementsId: "84518214-de1d-4750-9314-38136d1e3157",
  targetYear: 2020,
  applyStartMonth: new Date(),
  yearOvertimeList: [14400,30000,43200],
  yearOvertimeHourList: [240,500,720],
  monthlyOverConditionsCountList: [1,3,4,6],
  monthOverConditionsHour:40,
  monthlyOverAndHolidayTimeHour: 100
}

export const useYearlyAgreement36Form = () => {
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || "";
  const [orgCode, setOrgCode] = useState(sessionStorage.getItem('loginUser.orgCode') || '');
  const [checkboxThreshold, setCheckboxThreshold] = useState<boolean[]>([true, true, true, true])
  const [checkboxThresholdCondition, setCheckboxThresholdCondition] = useState<boolean[]>([true, true, true, true])
  const [yearlyAgreement36Data, setYearlyAgreement36Data] = useState<YearlyAgreement36Data>(initYearlyAgreement36Data);
  const [yearlyInfoData, setYearlyInfoData] = useState<YearlyInfoAgreement36Data[]>();
  const [staffDetail, setStaffDetail] = useState<Attend36AgreementsAlertData[]>();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [applyYear, setApplyYear] = useState(new Date().getFullYear());
  const [applyStartMonth, setApplyStartMonth] = useState(new Date());
  const addAllItem = sessionStorage.getItem('loginUser.site') === '3';
  const orgTreesOptions = useOrgTreesByYear(applyYear, setIsLoading, addAllItem);

  const [flag, setFlag] = useState(false)

  const fetchYearInfo = async (yearlyData: YearlyAgreement36Data, applyDate: Date, checkboxYear: boolean[], checkboxOverCondition: boolean[]) => {
    setIsLoading(true);
    let params = {
      targetMonth: moment(applyDate).format('YYYY/MM/01'),
      orgCode,
      yearOverTimeAry: yearlyData.yearOvertimeList?.filter((item, index) => checkboxYear[index]).join(),
      overConditionsCountAry: yearlyData.monthlyOverConditionsCountList?.filter((item, index) => checkboxOverCondition[index]).join(),
    }
    try {
      getYearInfoAgreement36Data(params).then((response: any) => {
        setIsLoading(false);
        setYearlyInfoData(response);
      }).catch((error: any) => {
        setYearlyInfoData(undefined)
        setIsLoading(false);
        if (error.status === 400) {
          if (error.data.errors && error.data.errors.length > 0) {
            errorNotification(
              error.data.errors.map((x: any) => x.defaultMessage)
            );
          } else if (error.data.defaultMessage) {
            errorNotification(error.data.defaultMessage);
          } else {
            errorNotification(error.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }  
      })
    } catch (error) {
      setYearlyInfoData(undefined);
      errorNotification('サーバー側でエラーが発生しました。');
      setIsLoading(false);
    }
  };

  const fetchDataDetailStaff = useCallback(async (staffCode: string) => {
    setIsLoading(true);
    let params = {
      staffCode,
      targetMonth: moment(applyStartMonth).format('YYYY/MM/DD')
    }
    try {
      getDetailStaffAgreement36(params).then((response: any) => {
        setStaffDetail(response);        
      }).catch((error: any) => {
        if (error.status === 400) {
          if (error.data.errors && error.data.errors.length > 0) {
            errorNotification(
              error.data.errors.map((x: any) => x.defaultMessage)
            );
          } else if (error.data.defaultMessage) {
            errorNotification(error.data.defaultMessage);
          } else {
            errorNotification(error.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }  
      }).finally(() => {
        setIsLoading(false);
      })
    } catch (error) {
      errorNotification('サーバー側でエラーが発生しました。');
    } finally{
    }
  }, [applyYear, applyStartMonth]);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setFlag(false);
    try {
      getYearAgreement36Data(applyYear).then((response: any) => {
        if(!response.agreementsId){
          errorNotification('36協定アラートマスタが登録されていません');
        }
        setApplyStartMonth(response.applyStartMonth);
        setYearlyAgreement36Data(response);
        if(response.applyStartMonth){
          fetchYearInfo(
            response, response.applyStartMonth, [true, true, true, true], [true, true, true, true]
          ).then(() => {
            setCheckboxThreshold([true, true, true, true]);
            setCheckboxThresholdCondition([true, true, true, true]);
          });  
        }else{
          setYearlyInfoData(undefined);
        }
      }).catch((error: any) => {
        if (error.status === 400) {
          if (error.data.errors && error.data.errors.length > 0) {
            errorNotification(
              error.data.errors.map((x: any) => x.defaultMessage)
            );
          } else if (error.data.defaultMessage) {
            errorNotification(error.data.defaultMessage);
          } else {
            errorNotification(error.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }  
      }).finally(() => {
        setFlag(true);
      })
    } catch (error) {
      errorNotification('サーバー側でエラーが発生しました。');
      setIsLoading(false);
    } finally{
      setIsLoading(false);
    }
  }, [applyYear]);

  useEffect(() => {
    if(flag){
      if(!yearlyAgreement36Data || !yearlyAgreement36Data.yearOvertimeHourList){
        errorNotification('36協定アラートマスタが登録されていません');
        return
      }
      fetchYearInfo(yearlyAgreement36Data, applyStartMonth, checkboxThreshold, checkboxThresholdCondition);
    }
  }, [checkboxThreshold, checkboxThresholdCondition, orgCode])

  useEffect(() => {
    fetchData();
  }, [applyYear]);
  
  const handleOpenDetail = (staffCode: string) => {
    setIsOpenModal(true);
    fetchDataDetailStaff(staffCode);
  }

  return {
    isLoading,
    applyYear,
    setApplyYear,
    staffCode,
    orgCode,
    setOrgCode,
    orgTreesOptions,
    checkboxThreshold,
    setCheckboxThreshold,
    yearlyAgreement36Data,
    yearlyInfoData,
    checkboxThresholdCondition,
    setCheckboxThresholdCondition,
    staffDetail,
    isOpenModal,
    setIsOpenModal,
    handleOpenDetail
  };
};

export default useYearlyAgreement36Form;
